import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';

const DeleteConfirmationModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = 'Confirm Delete', 
  message = 'Are you sure you want to delete this item?',
  itemName = '',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ pb: 1 }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography>
            {message}
            {itemName && (
              <Typography component="span" sx={{ fontWeight: 'bold' }}>
                {' '}{itemName}
              </Typography>
            )}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
            onClick={onClose}
            variant="contained"
            sx={{
              bgcolor: '#e0e0e0',
              color: '#000',
              '&:hover': { bgcolor: '#d5d5d5' },
              textTransform: 'none',
              borderRadius: 2,
              fontWeight: 600,
              px: 3,
              fontSize: '16px',
              lineHeight: '24px'
            }}
          >
            Cancel
          </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
              bgcolor: '#00694B',
              color: '#fff',
              '&:hover': { bgcolor: '#005039' },
              textTransform: 'none',
              borderRadius: 2,
              fontWeight: 600,
              px: 3,
              fontSize: '16px',
              lineHeight: '24px'
            }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
